export default function PHP_nl2br() {
  return (
    <div>
      <h1>PHP_nl2br</h1>
    </div>
  );
}
